import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiStripepaymentgatewaySetupIntentDetailQueryResponse,
  GetApiStripepaymentgatewaySetupIntentDetailQueryParams,
  GetApiStripepaymentgatewaySetupIntentDetail401,
  GetApiStripepaymentgatewaySetupIntentDetail403,
} from "../../../types/GetApiStripepaymentgatewaySetupIntentDetail";

export function getGetApiStripepaymentgatewaySetupIntentDetailUrl() {
  return `/api/StripePaymentGateway/setup-intent-detail` as const;
}

/**
 * {@link /api/StripePaymentGateway/setup-intent-detail}
 */
export async function getApiStripepaymentgatewaySetupIntentDetail(
  params?: GetApiStripepaymentgatewaySetupIntentDetailQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiStripepaymentgatewaySetupIntentDetailQueryResponse,
    ResponseErrorConfig<
      | GetApiStripepaymentgatewaySetupIntentDetail401
      | GetApiStripepaymentgatewaySetupIntentDetail403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiStripepaymentgatewaySetupIntentDetailUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
